module.exports = [
  require('./lake_of_steam'),
  require('./lantan'),
  require('./lapaliiya'),
  require('./luiren'),
  require('./luskan'),
]
